import { render, staticRenderFns } from "./EstablishmentList.vue?vue&type=template&id=55785393&scoped=true&lang=html&"
import script from "./EstablishmentList.vue?vue&type=script&lang=coffee&"
export * from "./EstablishmentList.vue?vue&type=script&lang=coffee&"
import style0 from "./EstablishmentList.vue?vue&type=style&index=0&id=55785393&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55785393",
  null
  
)

component.options.__file = "EstablishmentList.vue"
export default component.exports